module.exports = __webpack_public_path__ + "assets/retina_60RotationCWDetailed.52d0b661c38e783bdd93fd130610f4d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_60RotationCWDetailed.png
// module id = 603
// module chunks = 0